// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.102.1/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.102.1/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.aiiif-infobar {
    display: flex;
    flex-direction: row;
    height: 100%;
    width: 100%;
}

.aiiif-content0.aiiif-splitter-container .aiiif-infobar {
    flex-grow: 2;
}

.aiiif-tab-container {
    background-color: lightgrey;
    padding: 12px 9px;
    overflow-y: auto;
    scrollbar-width: thin;
    word-wrap: break-word;
    flex-grow: 2;
}
.aiiif-tab-container h2 {
    margin-top: 0;
    font-size: 1.2rem;
}

.aiiif-button-bar {
    min-width: 36px;
    max-width: 36px;
    background-color: darkgrey;
}

.aiiif-button-bar-right {
    position: absolute;
    right: 0;
    bottom: 0;
    left: 0;
}

.aiiif-button-bar > button {
    border: none;
    text-align: center;
    cursor: pointer;
    font-size: 1.5em;
    background: transparent;
    padding: 3px 0;
    width: 100%;
}

.aiiif-button-bar > button.active {
    background-color: lightgrey;
}


.aiiif-metadata-item {
    text-align: left;
    margin-bottom: 12px;
}

.aiiif-metadata-item > strong {
    margin-bottom: 3px;
    display: block;
}

.aiiif-metadata-item .svg-inline--fa {
    font-size: 1.7rem;
    margin: 3px 6px 6px 0;
}


.aiiif-image-preview.active > div > span {
    background-color: #7CD6FA;
    border-radius: 3px;
    color: black;
}

.aiiif-image-preview > div {
    margin-bottom: 15px;
    text-align: center;
}

.aiiif-image-preview > div > span {
    font-size: 0.8rem;
    color: #313335;
    padding: 3px;
}

.aiiif-image-preview > img {
    cursor: pointer;
    display: block;
    margin: 4px auto;
}
`, "",{"version":3,"sources":["webpack://./src/infoBar/infoBar.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,2BAA2B;IAC3B,iBAAiB;IACjB,gBAAgB;IAChB,qBAAqB;IACrB,qBAAqB;IACrB,YAAY;AAChB;AACA;IACI,aAAa;IACb,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,eAAe;IACf,0BAA0B;AAC9B;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,OAAO;AACX;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,uBAAuB;IACvB,cAAc;IACd,WAAW;AACf;;AAEA;IACI,2BAA2B;AAC/B;;;AAGA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,qBAAqB;AACzB;;;AAGA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB","sourcesContent":[".aiiif-infobar {\n    display: flex;\n    flex-direction: row;\n    height: 100%;\n    width: 100%;\n}\n\n.aiiif-content0.aiiif-splitter-container .aiiif-infobar {\n    flex-grow: 2;\n}\n\n.aiiif-tab-container {\n    background-color: lightgrey;\n    padding: 12px 9px;\n    overflow-y: auto;\n    scrollbar-width: thin;\n    word-wrap: break-word;\n    flex-grow: 2;\n}\n.aiiif-tab-container h2 {\n    margin-top: 0;\n    font-size: 1.2rem;\n}\n\n.aiiif-button-bar {\n    min-width: 36px;\n    max-width: 36px;\n    background-color: darkgrey;\n}\n\n.aiiif-button-bar-right {\n    position: absolute;\n    right: 0;\n    bottom: 0;\n    left: 0;\n}\n\n.aiiif-button-bar > button {\n    border: none;\n    text-align: center;\n    cursor: pointer;\n    font-size: 1.5em;\n    background: transparent;\n    padding: 3px 0;\n    width: 100%;\n}\n\n.aiiif-button-bar > button.active {\n    background-color: lightgrey;\n}\n\n\n.aiiif-metadata-item {\n    text-align: left;\n    margin-bottom: 12px;\n}\n\n.aiiif-metadata-item > strong {\n    margin-bottom: 3px;\n    display: block;\n}\n\n.aiiif-metadata-item .svg-inline--fa {\n    font-size: 1.7rem;\n    margin: 3px 6px 6px 0;\n}\n\n\n.aiiif-image-preview.active > div > span {\n    background-color: #7CD6FA;\n    border-radius: 3px;\n    color: black;\n}\n\n.aiiif-image-preview > div {\n    margin-bottom: 15px;\n    text-align: center;\n}\n\n.aiiif-image-preview > div > span {\n    font-size: 0.8rem;\n    color: #313335;\n    padding: 3px;\n}\n\n.aiiif-image-preview > img {\n    cursor: pointer;\n    display: block;\n    margin: 4px auto;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
